import { USERS_COLLECTION } from '../../../constants'
import { FirestoreClient, UnscopeUser } from '../../../types'
import { FirestoreAdmin } from '../../../types/FirestoreAdmin'
import firebase from 'firebase'

interface Props<T extends FirestoreClient | FirestoreAdmin> {
  firestore: T
  userId: string
}

export const getUnscopeUserRef = <T extends FirestoreClient | FirestoreAdmin>({
  firestore,
  userId,
}: Props<T>): T extends FirestoreClient
  ? firebase.firestore.DocumentReference<UnscopeUser>
  : FirebaseFirestore.DocumentReference => {
  return firestore.collection(USERS_COLLECTION).doc(userId) as any
}
